/**
 * Will compare the file extension with the given provided extension
 * and returns boolean based on the on the result
 */
export const compareFileExtension = (
  file: File | null,
  extension: string,
): boolean => {
  // To replace the . in extension with null value
  if (extension.includes('.')) {
    extension = extension.replace('.', '')
  }

  // To Get the extension of received filename
  let fileExt

  if (file?.name) {
    const fileExtArray = file?.name.split('.')
    fileExt = fileExtArray[fileExtArray?.length - 1]
  }

  if (fileExt === extension) {
    return true
  }
  return false
}

export const compareMultipleFileExtension = (
  file: File | null,
  extensions: string[],
): boolean => {
  if (!file?.name) return false

  // Get file extension
  const fileName = file.name.toLowerCase()
  const fileExtension = fileName.substring(fileName.lastIndexOf('.'))

  // Check if file extension matches any supported extension
  return extensions.some((ext) => ext.toLowerCase() === fileExtension)
}
